import { ChainId } from '@pancakeswap-libs/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x547212eaB5242562e42125a0F82c91bf8404f63d', // TODO
  [ChainId.BSCTESTNET]: '0x547212eaB5242562e42125a0F82c91bf8404f63d',
  [ChainId.PSC]: '0x547212eaB5242562e42125a0F82c91bf8404f63d'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
